import styled from "styled-components";

export const SideBarItemContainer = styled.li<{selected: boolean, showFull: boolean}>`
  width: 100%;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #424242;
  white-space: nowrap;

  svg {
    min-width: 1em;
    font-size: 1.25rem;
    color: ${({selected, theme}) => selected ? theme.colors.primaryPurple.main : "#616161"};
    margin-right: 1.2rem;
  }

  &:hover {
    background-color: #fffa;
    cursor: pointer;
    svg {
      color: ${({theme}) => theme.colors.primaryPurple.main}
    }
  }
`;

export const SideBarItemLabel = styled.span`
  font-size: 1rem;
`;
